import S, { maybeShape } from 'common/service/sanctuary';
import React from 'react';
import { connect } from 'react-redux';
import Icon from 'common/mdc/icon';
import { string, node, shape } from 'prop-types';

import {
  selectors,
} from 'common/store/server/links';

const getUrl = (isC4, c4SearchUrl, nodeId, deviceId, dcsSearchUrl) => {
  if(isC4){
    return c4SearchUrl.replace("%s", `c4/${nodeId}/${deviceId}`);
  }
  return dcsSearchUrl.replace("%s", `${deviceId}`);
}

const NodeLink = ({ nodeId, terminalReferenceId, children, maybeLink, style, 
  isC4,
  dcsLink,
  dcsSearchUrl,
  c4SearchUrl,
  deviceId,
 }) => S.maybe(
  <span>{nodeId}{terminalReferenceId}</span>,
  link => {

    const isValidUrl = (isC4 && c4SearchUrl.includes("%s")) || (!isC4 && dcsSearchUrl.includes("%s"));
    return isValidUrl ? (
      <a
        onClick={(e) => { e.stopPropagation(); }}
        href={`${getUrl(isC4, c4SearchUrl, nodeId, deviceId, dcsSearchUrl)}`}
        className="mdc-list-item nodeLink"
        style={style}
      >
        <span className="description">{children}</span>
        &nbsp;
        <Icon className="mdc-list-item__graphic" aria-hidden="true">open_in_new</Icon>
    </a>
    ) : (<span className="description">{children}</span>)

  },
  maybeLink,
);

NodeLink.propTypes = {
  nodeId: string.isRequired,
  terminalReferenceId: string.isRequired,
  children: node.isRequired,
  maybeLink: maybeShape,
  style: shape(),
};

NodeLink.defaultProps = {
  style: {},
};

export default connect(
  state => ({
    maybeLink: selectors.getLink(state)('nms'),
    dcsLink: state.server.links.data === undefined ? "" : state.server.links.data.dcs,
    dcsSearchUrl: state.server.links.data === undefined ? "" : state.server.links.data.dcsSearch,
    c4SearchUrl: state.server.links.data === undefined ? "" : state.server.links.data.c4Search,
  }),
)(NodeLink);
